import Axios from 'axios'

import { SERVER_BASE_URL } from '../baseUrl'

export const modifyTarif = async (token: string, tarifData: object) => {
  try {
    const response = await Axios.patch(`${SERVER_BASE_URL}api/profileVisiteur/tarif`, tarifData, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })

    return response.data
  } catch (error) {
    console.error('Erreur lors de la requête :', error)
    throw error
  }
}
